import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams , ViewController } from 'ionic-angular';
import { clientes } from '../../models/clientes'
import { ClientesProvider } from '../../providers/clientes/clientes'
import { EntidadesProvider } from '../../providers/entidades/entidades';
import { ParametrosGeneralesRedux } from '../../providers/redux/parametrosgenerales/parametrosgenerales';
import { Storage } from '@ionic/storage'
import { Observable } from 'rxjs/Observable';
@IonicPage()
@Component({
  selector: 'page-clientes-editar',
  templateUrl: 'clientes-editar.html',
  providers: [  ParametrosGeneralesRedux, EntidadesProvider ],
})
export class ClientesEditarPage {


  clientes: Array<clientes> = []
  cliente:clientes[] = []
  clienteCopia:clientes[] = []
  fechaExpedicion:string =""
  fechaIngreso:string =""
  tipoIdentificacion:string = ""
  numeroTelefono:string=""
  direccion:string=""
  companiasId;
  entidadesId:any
  isFocused: boolean = false;
  isFocusedFechaExpedicion: boolean = false;

  constructor(public navCtrl: NavController, public navParams: NavParams,
              public viewControllers:ViewController,utils:ClientesProvider,
              public servicioEntidades: EntidadesProvider,
              public utilsParametrosGeneralesRedux: ParametrosGeneralesRedux,
              public storages:Storage,) {
    if(this.navParams.get('clientes')){
      let data = this.navParams.get('clientes')
    this.cliente = this.extender(this.cliente,{
        tipoIdentificacion : data.tipoIdentificacion,
        identificacion : data.identificacion,
        digito : data.digito,
        //fechaExpedicion : data.fechaExpedicion,
        primerApellido : data.primerApellido,
        segundoApellido : data.segundoApellido,
        primerNombre : data.primerNombre,
        segundoNombre : data.segundoNombre,
        nombreCompleto : `${data.primerNombre} ${data.segundoNombre} ${data.primerApellido} ${data.segundoApellido} ` ,
        //fechaIngreso : data.fechaIngreso,
        estado : data.estado,
        queHago: "A",
        clientesId : data.clientesId,
        nombreTabla: "clientes",
        name: "dataDynamicCrud",
        numeroTelefono:data.numeroTelefono,
        direccion:data.direccion,
        correoElectronico: data.correoElectronico,
        entidadesId: data.entidadesId
      })
      // let fechaExpedicion = new Date(this.cliente['fechaExpedicion'])
      // let nuevafechaExpedicion = fechaExpedicion.toLocaleDateString()
      // nuevafechaExpedicion = nuevafechaExpedicion.split('/').reverse().join('-')
      // this.fechaExpedicion = utils.formatearCadena(nuevafechaExpedicion)

      //let fechaIngreso = new Date(this.cliente['fechaIngreso'])
      //let nuevafechaIngreso = fechaIngreso.toLocaleDateString()
      //nuevafechaIngreso = nuevafechaIngreso.split('/').reverse().join('-')
      //this.fechaIngreso = utils.formatearCadena(nuevafechaIngreso)
      let digito = this.cliente['digito'] == null ? 0 : this.cliente['digito']
      // this.cliente['fechaIngreso'] = this.fechaIngreso
      // this.cliente['fechaExpedicion'] = this.fechaExpedicion
      this.cliente['digito'] = digito
    }
    this.buscarDatosIniciales()
  }

  async buscarDatosIniciales() {
    let buscarParametrosGeneralesStore: any = await this.utilsParametrosGeneralesRedux.buscarParametrosGeneralesStore()
    if(buscarParametrosGeneralesStore !== null && buscarParametrosGeneralesStore.parametrosGenerales !== null) {
      this.companiasId = buscarParametrosGeneralesStore.parametrosGenerales[0][0].companiasId
    } else {
      this.storages.get('companiasId').then((val) => {
        this.companiasId = val
      })
    }
  }

  extender (obj, values) {
    const clone = Object.assign({}, obj)
    return Object.assign(clone, values)
  }


  dismiss(){
    this.viewControllers.dismiss();
  }

  submit(){
  if(this.entidadesId != undefined && this.entidadesId.length > 0 && this.entidadesId[0].value != undefined ) {
    this.cliente['entidadesId'] = this.entidadesId[0].value
  }
   this.viewControllers.dismiss(this.cliente);
  }
  public requestAutocompleteItems = (text: string): Observable<Response> => {
    return this.servicioEntidades.buscarEntidadPorCompania(text, this.companiasId)
  };

  onFocus() {
    this.isFocused = true;
  }

  onBlur() {
    this.isFocused = false;
    this.validateDate();
  }

  validateDateFechaExpedicion() {
    const regex = /^\d{4}-\d{2}-\d{2}$/;
    if (!regex.test(this.fechaExpedicion)) {
      alert('Por favor, ingresa una fecha válida en el formato YYYY-MM-DD');
      this.fechaExpedicion = '';
    }
  }

  onBlurFechaExpedicion() {
    this.isFocusedFechaExpedicion = false;
    this.validateDateFechaExpedicion();
  }

  onFocusFechaExpedicion() {
    this.isFocusedFechaExpedicion = true;
  }

  validateDate() {
    const regex = /^\d{4}-\d{2}-\d{2}$/;
    if (!regex.test(this.fechaIngreso)) {
      alert('Por favor, ingresa una fecha válida en el formato YYYY-MM-DD');
      this.fechaIngreso = '';
    }
  }


  async ionViewDidLoad() {
    const element = document.getElementsByClassName('modal-wrapper')[0] as HTMLElement;
    element.style.height = '100%';
    element.style.width = '100%';
    element.style.top = '0';
    element.style.left = '0';
    element.style.right = '0';
    element.style.bottom = '0';
  }


}



// WEBPACK FOOTER //
// ./src/pages/clientes-editar/clientes-editar.ts